module.exports = __webpack_public_path__ + "static/cottons-d28a5a00845a9a14c18fbdac429f8248.png";